import dayjs from "dayjs";

export interface RowsData {
  id: number | string;
  PerfilCliente: PerfilCliente;
  email: string | null;
  codigoPermissao: Permissions;
  status?: boolean;
  verificado?: boolean;
  online?: boolean;
  RlPageUserPermission?: [];
}

export interface PerfilCliente {
  id?: number | string;
  nome?: string;
  sobrenome?: string;
  nomeFantasia?: string;
  foto?: string;
  pessoaFisica?: boolean;
  dataDeNascimento?: dayjs.Dayjs;
  telefone?: string;
  cpf?: string;
  cnpj?: string;
}
export interface RowsDataSource {
  id: string;
  databaseName: string | null;
  host: string | null;
  name: string | null;
  password: string | null;
  port: number | null;
  userName: string | null;
  enumType: keyof typeof TypeDataSource;
  sshTunnel: SshTunnel | null;
  default?: boolean;
}

export interface SshTunnel {
  host: string | null;
  port: number;
  sshUser: string | null;
  sshPassword: string | null;
  dataSourceId: string | null;
  dataSource: RowsDataSource;
}

export enum TypeDataSource {
  POSTGRES = "PostgresSQL",
  MYSQL = "MySql",
  MARIADB = "MariaDB",
}

export type Permissions = "adm001" | "adm002" | "user001";

export type StatusOption = {
  value: string | boolean;
  label: string;
};
